import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";

export default class BillingTestPair extends FirebaseModel {
	static entity = 'billingTestPairs';
	static baseCollection = this.firestore.collection('Configs').doc('Belit').collection('test_pair_discounts');
	static fields(){
		return {
			name: this.attr(null),
			has_tests: this.attr(null),
			discount: this.number(null),
			...super.fields()
		}
	}
}
